import { NCardSelectOption } from '@next-is-free-monorepo/nif-web-components';
import { motion } from 'framer-motion';
import { RadioGroup, RadioGroupItem, Button } from '@virlewood/board-79';
import { useOnboardingStore } from '../../stores/useOnboardingStore';
import { useId } from 'react';

interface ChooseCategoryProps {
}

const options: NCardSelectOption[] = [
  {
    title: 'Ristorazione e Bar',
    subtitle: 'Ristoranti, gelaterie, bar...',
    image: '/illustrations/hamburger.webp',
    value: '7b2e1ff5-f23a-43f9-82bc-20ac72f133bd'
  },
  {
    title: 'Bellezza e Benessere',
    subtitle: 'Parrucchieri, estetiste, Spa...',
    image: '/illustrations/parrucchieri.webp',
    value: '956ede8f-3646-4328-809e-fea199026b1c'
  },
  {
    title: 'Negozi Alimentari',
    subtitle: 'Fornerie, macellerie, gastronomie...',
    image: '/illustrations/groceries.webp',
    value: 'e4da7c0c-5eb3-42f7-ab82-eab79e72a915'
  },
  {
    title: 'Artigianato e servizi',
    subtitle: 'Artigiani, lavanderie, idraulici...',
    image: '/illustrations/tools.webp',
    value: 'eec0c763-5b58-44ab-848c-260e057bcb82'
  },
  {
    title: 'Negozi e retail',
    subtitle: 'Abbigliamento, farmacie, articoli sportivi...',
    image: '/illustrations/shopping.webp',
    value: 'cd35ca46-bd2d-4a54-98d0-760fdd6a873d'
  },
  {
    title: 'Altro',
    image: '/illustrations/planet.webp',
    value: '56ffabe3-5b9b-4fa0-bd49-db5a42817ee0'
  }
];

const ChooseCategory = () => {

  const { updateData, data, nextStep } = useOnboardingStore(state => state);
  const id = useId();

  const handleCategoryChange = (value: string) => {
    updateData({ business_category: value, goals: undefined });
  };

  const handleContinue = () => {
    if (data.business_category) {
      nextStep();
    }
  };

  return (
    <div className="flex flex-col items-center gap-8">
      <RadioGroup onValueChange={handleCategoryChange} value={data.business_category}
                  className="w-full grid p-4 grid-cols-2 max-w-4xl gap-4 mt-10">
        {options.map((item, index) => (
          <motion.div
            onClick={() => handleCategoryChange(item.value)}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: index * 0.1 + 0.2 }}
            key={`${id}-${item.value}`}
            className="rounded-md cursor-pointer has-data-[state=checked]:border-primary has-data-[state=checked]:scale-100 has-data-[state=checked]:bg-primary/10 scale-95 border-2 relative flex flex-col md:flex-row gap-4  p-4 md:p-2 outline-none has-data-[state=checked]:z-10"
          >
            <div className="flex items-center justify-end gap-2 md:hidden">
              <RadioGroupItem
                id={`${id}-${item.value}`}
                value={item.value}
                className="after:absolute after:inset-0 top-4 size-5 right-4"
                aria-label={`plan-radio-${item.value}`}
                aria-describedby={`${`${id}-${item.value}`}-price`}
              />
            </div>
            <img
              className={`transition-transform md:w-30 rounded-sm ${data.business_category === item.value ? 'scale-100 saturate-100' : 'scale-95'}`}
              src={item.image} alt={item.title} />
            <div className="flex items-center justify-between">
              <div id={`${`${id}-${item.value}`}-price`}
                   className="">
                <p className={'font-bold text-lg'}>
                  {item.title}
                </p>
                <p className={'text-sm text-muted-foreground'}>
                  {item.subtitle}
                </p>
              </div>
            </div>
          </motion.div>
        ))}
      </RadioGroup>
      <div className={'bg-background sticky bottom-0 w-full px-4 py-4 mask-t-from-80% flex justify-center gap-4 z-55'}>
        <Button
          onClick={handleContinue}
          variant="primary"
          size="lg"
          className="min-w-sm"
          disabled={!data.business_category}
        >
          Continua
        </Button>
      </div>

    </div>);
};
export default ChooseCategory;
